import React, { Component } from "react";
//import * as _ from "lodash";
//import classNames from "classnames";

import QuizUi from "./widgets/QuizUi";

import { createQuestionFromSeed, dayOfWeek } from "./QuizDay";

import "./QuizYear.css";

const getYearValue = (year) => {
  return dayOfWeek(year, 2, 5); // 5th of March aligns with year value (don't use Jan/Feb due to leap year rule)
};

class QuizYear extends Component {
  state = {
    answer: null,
  };

  componentWillMount() {}

  componentDidMount() {
    this.createQuestion();
  }

  componentDidUpdate(prevProps) {
    if (this.props.seed !== prevProps.seed) {
      this.createQuestion();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  createQuestion() {
    const { seed, fromYear, toYear } = this.props;

    const { year } = createQuestionFromSeed(seed, fromYear, toYear);

    this.setState({
      answer: null,
      isCorrect: false,
      isWrong: false,
      wrongCount: 0,
      year,
    });
  }

  onAnswer = (num) => {
    const correctValue = getYearValue(this.state.year);
    const isCorrect = correctValue === num;
    this.setState(
      {
        answer: num,
        isCorrect,
        isWrong: !isCorrect,
      },
      this.waitAfterAnswer
    );
  };

  waitAfterAnswer = () => {
    this.timeout = setTimeout(this.afterWait, 1000);
  };

  afterWait = () => {
    if (this.state.isCorrect) {
      this.props.resetSeed();
    } else {
      this.setState({
        answer: null,
        isWrong: false,
        wrongCount: this.state.wrongCount + 1,
      });
    }
  };

  render() {
    const { year, answer, isCorrect, isWrong } = this.state;
    if (year === null) {
      return null;
    }

    const disabled = isCorrect || isWrong;

    return (
      <QuizUi className="QuizYear"
        hide789
        answer={answer}
        disabled={disabled}
        isCorrect={isCorrect}
        isWrong={isWrong}
        onAnswer={this.onAnswer}>
        <strong className="-title">Practice Year Calculation</strong>
        <strong className="-question">Number for {year}?</strong>
      </QuizUi>
    );
  }
}

export default QuizYear;
